// extracted by mini-css-extract-plugin
module.exports = {"conversationButton":"responseReviewerConversation_conversationButton__2SAwL","conversationLink":"responseReviewerConversation_conversationLink__1QQAy"};